// _Generated with AI_

export const referralTypes = [
  'Pinterest',
  'A Friend Referred Me',
  'Search Engine',
  'Facebook',
  'Twitter',
  'Instagram',
  'Other',
  'Unknown',
] as const;
